import { TimeDomain, type EventPlaybackRange } from '@/types/video-player';
import type { StreamingTimeline } from '@/types/streaming';

export const TIMELINE_CONTEXT_PADDING_SECONDS = 5 * 60;

export function buildEventDisplayTimeline(
    streamingTimeline: StreamingTimeline | null,
    eventRange: EventPlaybackRange | undefined,
): StreamingTimeline | null {
    if (!eventRange || eventRange.domain !== TimeDomain.ABSOLUTE) {
        return streamingTimeline;
    }

    const earliest = Math.max(
        0,
        eventRange.start - TIMELINE_CONTEXT_PADDING_SECONDS,
    );
    const latest = eventRange.end + TIMELINE_CONTEXT_PADDING_SECONDS;

    return {
        intervals: streamingTimeline?.intervals ?? [],
        earliest,
        latest,
        totalDuration: latest - earliest,
    };
}
